import { Checkbox, FormGroup, FormControlLabel } from "@material-ui/core";
import { showErrorMessage } from "./ShowFeildValidationError.jsx";

const ParticipantsFilter = ({
  filterBy,
  onFilterChange,
  errorMsg,
  labels,
  filterKey,
  errorKey,
}) => {
  const handleCheckboxChange = (e, field, filterKey, errorKey) => {
    onFilterChange(e, field, filterKey, errorKey);
  };

  return (
    <div className="row" style={{ marginTop: 18 }}>
      <label className="col-3 form-control-label mt-2 content-body required label">
        {labels.text}
      </label>

      <div className="col-9">
        <FormGroup row>
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                checked={filterBy.activeFilter}
                onChange={(e) =>
                  handleCheckboxChange(e, "activeFilter", filterKey, errorKey)
                }
              />
            }
            label={labels.activeLabel}
          />
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                checked={filterBy.inActiveFilter}
                onChange={(e) =>
                  handleCheckboxChange(e, "inActiveFilter", filterKey, errorKey)
                }
              />
            }
            label={labels.inActiveLabel}
          />
        </FormGroup>
      </div>
       {errorMsg && showErrorMessage(errorMsg)}
    </div>
  );
};

export default ParticipantsFilter;
